import Vue from "vue";
import VueI18n from "vue-i18n";
import es from "../locales/es.json";
import en from "../locales/en.json";

Vue.use(VueI18n);
const messages = {
  es,
  en,
};

export const i18n = new VueI18n({
  locale: "es",
  fallbackLocale: "en",
  messages,
});
